module.exports = __webpack_public_path__ + "static/media/Group 18.a08288c4.png";